export default __webpack_public_path__ + "media/2.90a01.png";